export default __webpack_public_path__ + "static/media/reproved_compliance_rule_icon.a069c8c5.svg";